import { createSlice } from '@reduxjs/toolkit';

const initialState = { loading: false, verifying: false, error: null };

const inceptionSlice = createSlice({
	name: 'inception',
	initialState,
	reducers: {
		verifyConnection: (state) => {
			state.verifying = true;
			state.error = null;
		},
		verifyConnectionSuccess: (state) => {
			state.verifying = false;
		},
		verifyConnectionError: (state, action) => {
			state.verifying = false;
			state.error = action.payload;
		},
		triggerSync: (state) => {
			state.loading = true;
			state.error = null;
		},
		triggerSyncSuccess: (state) => {
			state.loading = false;
		},
		triggerSyncError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		// Reset on logout so org A's in-flight verify/error never renders on org B.
		builder.addCase('auth/logout', () => initialState);
	}
});

export const inceptionActions = inceptionSlice.actions;
export default inceptionSlice.reducer;
